import * as React from 'react';

type Props<Row> = {
  children: (selected?: Row[]) => JSX.Element;
  selected?: Row[];
};

/**
 * @summary Компонент отображения checkbox.
 *
 * @param props.children - Функция, принимающая объект с данными о выбранных строках таблицы и возвращающая кнопку для удаления выбранных элементов.
 * @param props.selected - Выбранные элементы.
 */
export const SelectButton = <Row,>({ children, selected }: Props<Row>) => <>{children(selected)}</>;

SelectButton.displayName = 'SelectButton';

export type SelectButtonType<Row> = (props: Props<Row>) => JSX.Element;

export type SelectButtonRender<Row> = React.FunctionComponentElement<Props<Row>>;
